import React, { useState } from "react";
import toast from "react-hot-toast"; // For user feedback

const BimerEmailStep = ({ onEmailChosen }) => {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	// Email validation function
	const isValidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const handleEmailLogin = async () => {
		if (!isValidEmail(email)) {
			setError("Veuillez entrer une adresse e-mail valide.");
			toast.error("Adresse e-mail invalide !");
			return;
		}

		setLoading(true);
		setError(null);

		try {
			await onEmailChosen(email); // Calls parent function to handle email
		} catch (error) {
			console.error("Erreur lors de la connexion par email:", error);
			setError("Une erreur est survenue, veuillez réessayer.");
			toast.error("Une erreur est survenue.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Merci de prendre le temps de répondre aux questions!
			</h1>

			<div className="w-full">
				<p className="text-md text-gray-700 my-3">
					Saisissez votre adresse e-mail pour commencer:
				</p>

				{/* Email Input */}
				<input
					type="email"
					placeholder="Votre adresse e-mail"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-black"
				/>
			</div>

			{/* Error Message */}
			{error && <p className="text-red-500 text-sm text-center">{error}</p>}

			<div className="flex flex-col gap-2 items-center mt-8">
				<button
					onClick={handleEmailLogin}
					disabled={loading}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					{loading ? "Chargement..." : "Commencez le Quiz"}
				</button>
			</div>
		</div>
	);
};

export default BimerEmailStep;
